export default __webpack_public_path__ + "static/media/aba-terminal.ad331556.png";